<!--概览-->
<template>
	<div>
		<h3>数据概览</h3>
		<div class="item">
			<div class="parentcanve">
				<div class="col">
                    <div class="back" style="background: linear-gradient(0deg,#38c3b0,#00d5b8);">
                        <span>0</span>
                        <h5>本月生产状况</h5>
                    </div>
                </div>
                <div class="col">
                    <div class="back" style="background: linear-gradient(-60deg,#ffd900,#ffc52a);">
                        <span>0</span>
                        <h5>本月销售状况</h5>
                    </div>
                </div>
                <div class="col">
                    <div class="back" style="background: linear-gradient(0deg,#ff864b,#ff4905);">
                        <span>0</span>
                        <h5>本月防伪状况</h5>
                    </div>
                </div>
                <div class="col">
                    <div class="back" style="background: linear-gradient(0deg,#ca79fa,#b047fb);">
                        <span>0</span>
                        <h5>本月疑似窜货状况</h5>
                    </div>
                </div>
                <div class="col">
                    <div class="back" style="background: linear-gradient(0deg,#2dcffd,#23b2f8);">
                        <span>0</span>
                        <h5>本月异常状况</h5>
                    </div>
                </div>
			</div>
		</div>
		<div>
            <div class="parentcanve">
                <div class="lines">
                    <div :style="{height:'300px',width:'100%'}" ref="eChart1" id="echart1"></div>
                </div>
                <div class="lines" style="margin-left: 30px">
                    <div :style="{height:'300px',width:'100%'}" ref="eChart2" id="echart2"></div>
                </div>
            </div>
		</div>
        <div>
            <div class="map">
                <div :style="{height:'500px',width:'60%'}" ref="eChart3" id="echart3"></div>
                <div :style="{height:'500px',width:'35%',float:'right'}" ref="eChart4" id="echart4"></div>
            </div>
        </div>
        <div style="margin:20px 0;">
            <div class="parentcanve" >
                <div class="lines" style="margin-right: 10px;">
                    <div :style="{height:'300px',width:'100%'}" ref="eChart5" id="echart5"></div>
                </div>
                <div class="lines" style="margin-right: 10px;">
                    <div :style="{height:'300px',width:'100%'}" ref="eChart6" id="echart6"></div>
                </div>
                <div class="lines">
                    <div :style="{height:'300px',width:'100%'}" ref="eChart7" id="echart7"></div>
                </div>
            </div>
		</div>
	</div>
</template>

<script>
import echarts from "echarts";//引入图表
import '../../node_modules/echarts/map/js/china.js' // 引入中国地图数据
export default {
	data(){
		return {
			option1 : {
                title: {
                    text: '本年产量趋势'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['产量']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
                },
                yAxis: {
                    type: 'value',
                    splitLine:'false'
                },
                series: [
                    {
                        name: '产量',
                        type: 'line',
                        stack: '总量',
                        data: [120, 132, 101, 134, 90, 230, 210],
                        symbol: "none",//去掉曲线上的圆点
                        smooth: true,
                        areaStyle: {}, //堆叠图
                        itemStyle: {
                            normal:{
                                color: '#b047fb',//线条颜色
                                lineStyle:{
                                        width:2//设置线条粗细
                                    }
                            }
                        },
                        areaStyle: {
                            //渐变色
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#b047fb'
                            }, {
                                offset: 1,
                                color: '#ffe'
                            }])
                        },
                    }
                ]
            },
            option2 : {
                title: {
                    text: '本年销量趋势'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['销量']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                },
                yAxis: {
                    type: 'value',
                    splitLine:'false'
                },
                series: [{
                    name: '销量',
                    data: [820, 932, 901, 934, 1290, 1330, 1320],
                    type: 'line',
                    smooth: true,
                    symbol: "none",//去掉曲线上的圆点
                    areaStyle: {}, //堆叠图
                    itemStyle: {
                        normal:{
                            color: '#f63c3c',//线条颜色
                            lineStyle:{
                                    width:2//设置线条粗细
                                }
                        }
                    },
                    areaStyle: {
                        //渐变色
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: '#f63c3c'
                        }, {
                            offset: 1,
                            color: '#ffe'
                        }])
                    },
                }]
            },
            option3 : {
                title: {
                    text: '本年疑似窜货热点'
                },
                backgroundColor: "",
                tooltip: {}, // 鼠标移到图里面的浮动提示框
                dataRange: {
                    show: false,
                    min: 0,
                    max: 1000,
                    text: ['High', 'Low'],
                    realtime: true,
                    calculable: true,
                    color: ['orangered', 'yellow', 'lightskyblue']
                },
                geo: { // 这个是重点配置区
                    map: 'china', // 表示中国地图
                    zoom:1.2,
                    roam: false,//支持扩大缩小
                    label: {
                        normal: {
                            show: true, // 是否显示对应地名
                            textStyle: {
                            color: 'rgba(0,0,0,0.6)'
                            }
                        }
                    },
                    itemStyle: {
                        normal: {
                            borderColor: 'rgba(0, 0, 0, 0.4)'
                        },
                        emphasis: {
                            areaColor: null,
                            shadowOffsetX: 0,
                            shadowOffsetY: 0,
                            shadowBlur: 20,
                            borderWidth: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                },
                series: [{
                    type: 'scatter',
                    coordinateSystem: 'geo' // 对应上方配置
                    },
                    {
                    name: '数量', // 浮动框的标题
                    type: 'map',
                    geoIndex: 0,
                    data: [{
                        "name": "北京",
                        "value": 599
                    }, {
                        "name": "上海",
                        "value": 142
                    }, {
                        "name": "黑龙江",
                        "value": 44
                    }, {
                        "name": "深圳",
                        "value": 92
                    }, {
                        "name": "湖北",
                        "value": 810
                    }, {
                        "name": "四川",
                        "value": 453
                    },{
                        "name": "湖南",
                        "value": 125
                    }]
                    }
                ]
            },
            option4 : {
                color: ['#3398DB'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                yAxis: [
                    {
                        type: 'category',
                        data: ['北京', '上海', '黑龙江', '深圳', '湖北', '四川','湖南'],
                        show:true,
                        axisLine:{
                            show:false
                        },
                        axisTick: {
                            show: false,
                        },
                        splitLine:{
                            show: false,
                        },
                        
                    }
                ],
                xAxis: [
                    {
                        show:false,
                        type: 'value',
                        splitLine:'false'
                    }
                ],
                series: [
                    {
                        name: '数量',
                        type: 'bar',
                        data: [599, 142, 44, 92, 810, 453, 125],
                        barWidth: 16,
                        itemStyle: {
                            emphasis: {
                                barBorderRadius: [0,7,7,0]
                            },
                            normal: {
                                barBorderRadius: [0,7,7,0]
                            }
                        }
                    }
                ]
            },
            option5 : {
                title: {
                    text: '全国经销商销量TOP10'
                },
                color: ['#3398DB'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                yAxis: [
                    {
                        type: 'category',
                        data: ['北京', '上海', '黑龙江', '深圳', '湖北', '四川','湖南'],
                        show:true,
                        axisLine:{
                            show:false
                        },
                        axisTick: {
                            show: false,
                        },
                        splitLine:{
                            show: false,
                        },
                        
                    }
                ],
                xAxis: [
                    {
                        show:false,
                        type: 'value',
                        splitLine:'false'
                    }
                ],
                series: [
                    {
                        name: '数量',
                        type: 'bar',
                        barWidth: 16,
                        data: [599, 142, 44, 92, 810, 453, 125],
                        itemStyle: {
                            emphasis: {
                                barBorderRadius: [0,7,7,0]
                            },
                            normal: {
                                barBorderRadius: [0,7,7,0]
                            }
                        }
                    }
                ]
            },
            option6 : {
                title: {
                    text: '本年销量趋势'
                },
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                    splitLine:'false'
                },
                yAxis: {
                    type: 'value',
                    splitLine:'false'
                },
                series: [{
                    name: '销量',
                    data: [820, 932, 901, 934, 1290, 1330, 1320],
                    type: 'line',
                    areaStyle: {}, //堆叠图
                    smooth: true, //曲线
                    symbol: "none",//去掉曲线上的圆点
                    itemStyle: {
                        normal:{
                            color: '#8ec6ad',
                            lineStyle:{
                                    width:0//设置线条粗细
                                }
                        }
                    },
                    areaStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                            offset: 0,
                            color: '#8ec6ad'
                        }, {
                            offset: 1,
                            color: '#ffe'
                        }])
                    },
                }]
            },
            option7 : {
                title: {
                    text: '本月异常情况比例'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                legend: {
                    orient: 'horizontal',
                    left: 'center',
                    bottom:'bottom',
                    data: ['入库异常', '出库异常', '非本企业数码', '调库异常', '包装关系建立异常','其它']
                },
                series: [
                    {
                        name: '访问来源',
                        type: 'pie',
                        radius: ['50%', '65%'],
                        center: ['50%', '45%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: false,
                                fontSize: '30',
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: [
                            {value: 335, name: '入库异常'},
                            {value: 310, name: '出库异常'},
                            {value: 234, name: '非本企业数码'},
                            {value: 135, name: '包装关系建立异常'},
                            {value: 1548, name: '其它'}
                        ]
                    }
                ]
            },
		};
	},
	mounted : function(){
		var user = JSON.parse(sessionStorage.getItem('user'));
        this.initEcharts()
        
        var elementResizeDetectorMaker = require("element-resize-detector");//导入
        // 创建实例
        var erd = elementResizeDetectorMaker();
        // 创建实例带参
        var erdUltraFast = elementResizeDetectorMaker({
                        strategy: "scroll", //<- For ultra performance.
                        callOnAdd: true,
                        debug: true
                    });
        //监听id为test的元素 大小变化
        erd.listenTo(document.getElementById("echart1"), function(element) {
             let  myChart1 = echarts.init(document.getElementById('echart1'));
             myChart1.resize();
        });
        erd.listenTo(document.getElementById("echart2"), function(element) {
             let  myChart2 = echarts.init(document.getElementById('echart2'));
             myChart2.resize();
        });
        erd.listenTo(document.getElementById("echart3"), function(element) {
             let  myChart3 = echarts.init(document.getElementById('echart3'));
             myChart3.resize();
        });
        erd.listenTo(document.getElementById("echart4"), function(element) {
             let  myChart4 = echarts.init(document.getElementById('echart4'));
             myChart4.resize();
        });
        erd.listenTo(document.getElementById("echart5"), function(element) {
             let  myChart5 = echarts.init(document.getElementById('echart5'));
             myChart5.resize();
        });
        erd.listenTo(document.getElementById("echart6"), function(element) {
             let  myChart6 = echarts.init(document.getElementById('echart6'));
             myChart6.resize();
        });
        erd.listenTo(document.getElementById("echart7"), function(element) {
             let  myChart7 = echarts.init(document.getElementById('echart7'));
             myChart7.resize();
        });
	},
	methods: {
        //初始化
        initEcharts(){
            let  myChart1 = echarts.init(this.$refs.eChart1);
            myChart1.setOption(this.option1);
            
            let  myChart2 = echarts.init(this.$refs.eChart2);
            myChart2.setOption(this.option2);

            let  myChart3 = echarts.init(this.$refs.eChart3);
            myChart3.setOption(this.option3);

            let  myChart4 = echarts.init(this.$refs.eChart4);
            myChart4.setOption(this.option4);

            let  myChart5 = echarts.init(this.$refs.eChart5);
            myChart5.setOption(this.option5);

            let  myChart6 = echarts.init(this.$refs.eChart6);
            myChart6.setOption(this.option6);

            let  myChart7 = echarts.init(this.$refs.eChart7);
            myChart7.setOption(this.option7);
        }

	}
}
</script>

<style scoped>
.parentcanve{
    display:flex;
}
.col{
    text-align: center;
    width: 20%;
    float: left;
    color: white;
}
.col span{
    line-height: 60px;
    font-size: 36px;
    font-weight: 600;
}
.back{
    margin: 0 10px;
    padding: 10px;
    border-radius: 6px;
    height: 120px;
}
h5{
    font-size: 20px;
    font-weight: 400;
}
.lines{
    width: 40%;
    background: #f8f8f8;
    padding: 10px;
    display: inline-block;
    flex:1;
}
.map{
    margin-top: 20px;
    padding: 10px 10px;
    background: #f8f8f8;
    overflow:hidden;
    zoom:1;
}
.map div{
    float: left;
}
</style>


// WEBPACK FOOTER //
// src/pages/overview.vue